import MediaLibraryModal from './MediaLibraryModal';

export default MediaLibraryModal;
